import {BaseModel} from "../base";
import {QueuerModel} from "./queuer";

class ClientQueueModel extends BaseModel {

    /**
     * @description
     * override superclass method, define the ClientQueue Object
     *
     * @returns {object} The ClientQueue Object
     */
    updateModel(data) {
        if (data) {
            this._data = data;

            for (const property in data) {
                const value = data[property];
                if (typeof(value) !== 'function') {
                    this[property] = value;
                }
            }

            //const queuers = this.queuers.map( (val, index, arr) => new QueuerModel(val) );
            const queuers = this.queuers.map((item, index, arr) => {
                item.beingSeenMinutes = 0;
                item.multi_status.being_seen = moment(item.multi_status.being_seen);
                return new QueuerModel(item);
            });

            this.queuers = queuers;

            this.queuersBeingSeen = queuers.filter((item) => {
                return item.current_status == 'being_seen';
            });

            this.queuersCheckedIn = queuers.filter((item) => {
                return item.current_status == 'checked_in';
            });
        }
    }

}

export {
    ClientQueueModel
}